import clsx from 'clsx';

interface Props {
  date: string; // YYYY-MM-DD
  hasNote: boolean;
  isToday: boolean;
  // Compact for dense month cells; regular for week/day headers.
  variant?: 'cell' | 'header';
  onOpen: (date: string, rect: DOMRect) => void;
}

// The daily-note affordance pinned to a day. Today always shows it — there is
// always "today's note", created from the template on first open if the file
// doesn't exist yet. Past days show it only when a note already exists
// (creation is today-only). Clicking hands the date + anchor rect up so the
// editor can open (and, for today, create-on-open).
export default function DailyNotePin({ date, hasNote, isToday, variant = 'cell', onOpen }: Props) {
  if (!hasNote && !isToday) return null;

  function open(ev: React.MouseEvent) {
    ev.stopPropagation();
    onOpen(date, (ev.currentTarget as HTMLElement).getBoundingClientRect());
  }

  const compact = variant === 'cell';
  return (
    <button
      type="button"
      onClick={open}
      title="Daily note"
      aria-label="open daily note"
      className={clsx(
        'flex items-center gap-1 overflow-hidden whitespace-nowrap rounded text-left leading-none text-[var(--text-muted)] hover:bg-[var(--bg-hover)] hover:text-[var(--text)]',
        compact ? 'px-[5px] py-[2px] text-[0.7rem]' : 'px-[6px] py-[3px] text-[0.72rem]'
      )}
    >
      <span aria-hidden>📓</span>
      <span className="overflow-hidden text-ellipsis">Daily Note</span>
    </button>
  );
}
